"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.excludeHealthProbesTelemetryProcessor = void 0;
var excludeHealthProbesTelemetryProcessor = function(param) {
    var data = param.data;
    var _data_baseData_name, _data_baseData, _data_baseData_properties_url, _data_baseData_properties, _data_baseData1;
    if (data.baseType === 'RequestData' && ((_data_baseData = data.baseData) === null || _data_baseData === void 0 ? void 0 : (_data_baseData_name = _data_baseData.name) === null || _data_baseData_name === void 0 ? void 0 : _data_baseData_name.startsWith('GET /health/'))) {
        return false;
    }
    if (data.baseType === 'RemoteDependencyData' && ((_data_baseData1 = data.baseData) === null || _data_baseData1 === void 0 ? void 0 : (_data_baseData_properties = _data_baseData1.properties) === null || _data_baseData_properties === void 0 ? void 0 : (_data_baseData_properties_url = _data_baseData_properties.url) === null || _data_baseData_properties_url === void 0 ? void 0 : _data_baseData_properties_url.startsWith('/health/'))) {
        return false;
    }
    return true;
};
exports.excludeHealthProbesTelemetryProcessor = excludeHealthProbesTelemetryProcessor; //# sourceMappingURL=excludeHealthProbesTelemetryProcessor.js.map
